import { App } from '../App';
import useApplication from '../hooks/useApplication';

/* eslint-disable prettier/prettier */
// TODO: remove all those and use those useApiGlobal there instead.
export const useGetConstraints = (key?: string) =>
  App.useApi(
    'application/constraints/product-number/{productNumber}',
    'GET',
    key,
  );
export const useGetClientConstraints = (key?: string) =>
  App.useApi(
    'client/application/constraints/product-number/{productNumber}',
    'GET',
    key,
  );
export const useGetOffer = (key?: string) =>
  App.useApi(
    'application/first-loan-offer/product-number/{productNumber}',
    'GET',
    key,
  );
export const useGetClientOffer = (key?: string) =>
  App.useApi(
    'client/application/offer/product-number/{productNumber}',
    'GET',
    key,
  );
export const usePostLeadsRegister = (key?: string) =>
  App.useApi('leads', 'POST', key);
export const useGetClient = (key?: string) => App.useApi('client', 'GET', key);
export const useGetClientApplication = useApplication;
export const useGetClientApplicationProposals = (key?: string) =>
  App.useApi('client/application/proposals', 'GET', key);
export const usePostClientApplication = (key?: string) =>
  App.useApi('client/application', 'POST', key);
export const useGetClientApplicationCheckStatus = (key?: string) =>
  App.useApi('client/application/check-status', 'GET', key);
export const useGetLegalTerms = (key?: string) =>
  App.useApi('first-loan-legal-terms', 'GET', key);

export const usePutProfile = (key?: string) =>
  App.useApi('client/profile', 'PUT', key);
export const usePutApplication = (key?: string) =>
  App.useApi('client/application', 'PUT', key);
